import { useNavigate } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Stethoscope, Building2, ArrowRight } from "lucide-react";
import { toast } from "sonner";

export default function RoleSelection() {
  const navigate = useNavigate();
  const { checkAuth } = useAuth();

  const pick = async (role) => {
    try {
      await api.post("/auth/role", { role });
      await checkAuth();
      toast.success(`Welcome to MedShift as ${role === "doctor" ? "a Doctor" : "a Hospital"}`);
      navigate(`/${role}`);
    } catch (e) {
      toast.error("Could not set role");
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-6" data-testid="role-selection-page">
      <div className="max-w-3xl w-full">
        <div className="text-center mb-10">
          <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight">Welcome to MedShift</h1>
          <p className="text-slate-600 mt-2">Choose how you'll use the platform. You can only pick one.</p>
        </div>
        <div className="grid sm:grid-cols-2 gap-5">
          <Card className="p-8 hover:border-sky-400 border-2 transition cursor-pointer group" onClick={() => pick("doctor")} data-testid="role-doctor-card">
            <div className="w-12 h-12 rounded-xl bg-sky-50 text-sky-600 flex items-center justify-center">
              <Stethoscope className="w-6 h-6" />
            </div>
            <h3 className="mt-5 text-xl font-bold">I'm a Doctor</h3>
            <p className="text-sm text-slate-600 mt-1">Find verified duties, check-in on QR, get paid same-day.</p>
            <Button className="mt-6 w-full bg-sky-600 hover:bg-sky-700 rounded-xl" data-testid="pick-doctor-btn">
              Continue as Doctor <ArrowRight className="w-4 h-4 ml-1" />
            </Button>
          </Card>
          <Card className="p-8 hover:border-emerald-400 border-2 transition cursor-pointer group" onClick={() => pick("hospital")} data-testid="role-hospital-card">
            <div className="w-12 h-12 rounded-xl bg-emerald-50 text-emerald-600 flex items-center justify-center">
              <Building2 className="w-6 h-6" />
            </div>
            <h3 className="mt-5 text-xl font-bold">I'm a Hospital</h3>
            <p className="text-sm text-slate-600 mt-1">Post requirements, book best matches, approve attendance.</p>
            <Button className="mt-6 w-full bg-emerald-600 hover:bg-emerald-700 rounded-xl" data-testid="pick-hospital-btn">
              Continue as Hospital <ArrowRight className="w-4 h-4 ml-1" />
            </Button>
          </Card>
        </div>
      </div>
    </div>
  );
}
